
import TheLayoutExpiring from '@/pages/ExpiringPages/Layout/TheLayoutExpiring.vue'
import { EXTRANET_GROUPS } from './utils'

export default [
  {
    path: '/',
    name: 'Expiring Pages',
    component: TheLayoutExpiring,
    meta: {
      excludeGroup: EXTRANET_GROUPS
    },
    children: [
      {
        path: '/expiring_purchase_order_signing/:token',
        name: 'Purchase Order Signing',
        props: true,
        component: () => import('@/pages/ExpiringPages/PurchaseOrderSigning/index.vue'),
        meta: {
          showInSidebar: false,
          title: 'Firma Orde de compra'
        }
      }
    ]
  }
]
